interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode | string;
  when: boolean | undefined | null;
}

/**
 * Conditionally renders its children based on the `when` prop.
 *
 * @property {React.ReactNode} children - The content to render when `when` is true.
 * @property {boolean} when - Determines whether to render `children` or `fallback`.
 * @property {React.ReactNode | string} [fallback] - The content to render when `when` is false.
 */
export function Show({ children, when, fallback }: Props) {
  if (!when && fallback) {
    return fallback;
  }

  if (!when) {
    return null;
  }

  return children;
}
